import useMembershipEnabled from './useMembershipEnabled'
import { useMembershipStorage } from './useMembershipStorage'
import { useTokenContext } from '../contexts/token.context'

const useMembershipElementShow = () => {
    //check f21 flage value
    const isMembershipEnabled = useMembershipEnabled()

    //check membership status
    const { membershipStorage } = useMembershipStorage()
    const { membership_status } = membershipStorage || {}

    //check customer isLoggedin
    const tokenDB = useTokenContext()
    const isCustomerSignedIn = tokenDB && !tokenDB.anonymous

    return isMembershipEnabled || (membership_status === "ACTIVE" && isCustomerSignedIn)
}

export default useMembershipElementShow
